export default {
  Button: {
    render: () => null
  }
};
